module.exports = __webpack_public_path__ + "img/huoweizhuanyi-b.31a5dbd3.svg";